import { STORAGE_KEYS } from '@/constants/storage/keys'
import { AgencyUser, User } from '@prisma/client'
import { Session } from '@supabase/supabase-js'
import { cookies } from 'next/headers'

interface IGetUserObjectResponse {
  agencyIds: string[]
  agencyUser: AgencyUser & { Permissions: Array<Permissions> }
  landingId: string | null
  userInfo: {
    session: Session
    user: User
  }
}

export const getUserFromLocalStorage = (): IGetUserObjectResponse | null => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null // localStorage not available (e.g., SSR)
  }
  const user = localStorage.getItem(STORAGE_KEYS.USER_OBJ)
  if (!user) return null

  const parsedUser: IGetUserObjectResponse = JSON.parse(user)
  return parsedUser
}

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem(STORAGE_KEYS.USER_OBJ)
}
